// userPresenceStore.ts
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';
import { NewUserOnboardingStepsOrder } from '../constants';
import { NewUserOnboardingSteps, NewUserOnboardingStore } from '../types';

// Internal store setup
export const useNewUserOnboardingSubscribe = createStoreWithSubscribe<NewUserOnboardingStore>(
  (set) => ({
    currentState: NewUserOnboardingSteps.BEGIN_SETUP,
    currentStateIndex: 0,
    stopCountdown: false,
    userSelectedData: {
      view: 'expanded',
      notificationDisplayTime: 'display_until_dismissed',
    },
    isNewUserOnboardingComplete: false,

    setIsNewUserOnboardingComplete: () => {
      set({ isNewUserOnboardingComplete: true });
    },

    setCurrentStateIndex: (index: number) => {
      set({ currentStateIndex: index });
      set({ currentState: NewUserOnboardingStepsOrder[index] });
    },

    setStopCountdown: () => {
      set({ stopCountdown: true });
    },

    setUserSelectedData: (data: any) => {
      set({ userSelectedData: data });
    },
  }),
  {
    name: 'new-user-onboarding-store',
  }
);

// Internal shallow store for selective re-renders
export const useNewUserOnboardingStore = createShallowStore(useNewUserOnboardingSubscribe);
